import { render, staticRenderFns } from "./FundingRequestsPending.vue?vue&type=template&id=37e2824a&scoped=true&"
import script from "./FundingRequestsPending.vue?vue&type=script&lang=js&"
export * from "./FundingRequestsPending.vue?vue&type=script&lang=js&"
import style0 from "./FundingRequestsPending.vue?vue&type=style&index=0&id=37e2824a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e2824a",
  null
  
)

export default component.exports